import * as Yup from "yup";

const statusPersonalizadoOsValidator = Yup.array().of(
  Yup.object().shape({
    descricao: Yup.string().required("Descrição"),
    ordem: Yup.number().required("Ordem"),
    cor: Yup.string()
      .test("is-hex-color", "Cor deve ser um código hexadecimal válido", (value) => {
        const isValidHexColor = /^#([0-9A-F]{3}){1,2}$/i.test(value);
        return isValidHexColor;
      })
      .required("Cor"),
  }),
);

export default statusPersonalizadoOsValidator;
